import {
  INTEGRATIONS_FETCH_EMAILS_REQUEST,
  INTEGRATIONS_FETCH_EMAILS_SUCCESS,
  INTEGRATIONS_FETCH_EMAILS_FAILURE,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_REQUEST,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_SUCCESS,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_FAILURE,
} from '@core/constants/actions';
import { IntegrationsState } from '@core/types/state';

export const initialState: IntegrationsState = {
  emails: {
    items: [],
    isLoading: false,
    error: null,
  },
  emailDetail: {
    detail: null,
    isLoading: false,
    error: null,
  },
};

const integrationsReducer = (
  state: IntegrationsState = initialState,
  action: any
): IntegrationsState => {
  switch (action.type) {
    case INTEGRATIONS_FETCH_EMAILS_REQUEST:
      return {
        ...state,
        emails: {
          ...state.emails,
          isLoading: true,
          error: null,
        },
      };

    case INTEGRATIONS_FETCH_EMAILS_SUCCESS:
      return {
        ...state,
        emails: {
          items: action.emails,
          isLoading: false,
          error: null,
        },
      };

    case INTEGRATIONS_FETCH_EMAILS_FAILURE:
      return {
        ...state,
        emails: {
          ...state.emails,
          isLoading: false,
          error: action.error || 'Failed to fetch emails',
        },
      };

    case INTEGRATIONS_FETCH_EMAIL_DETAIL_REQUEST:
      return {
        ...state,
        emailDetail: {
          ...state.emailDetail,
          isLoading: true,
          error: null,
        },
      };

    case INTEGRATIONS_FETCH_EMAIL_DETAIL_SUCCESS:
      return {
        ...state,
        emailDetail: {
          detail: action.email,
          isLoading: false,
          error: null,
        },
      };

    case INTEGRATIONS_FETCH_EMAIL_DETAIL_FAILURE:
      return {
        ...state,
        emailDetail: {
          ...state.emailDetail,
          isLoading: false,
          error: action.error || 'Failed to fetch email detail',
        },
      };

    default:
      return state;
  }
};

export default integrationsReducer;
